export enum GlobalCareNoteRoutes {
  BASE = 'myaccount-ccn'
}
